import consolv from 'lib/consolv';

const defaultConfig = {
  fetch: {
    enabled: false,
    reportFrequency: 1,
    endpoint: 'https://h2ri5ur68e.execute-api.us-east-1.amazonaws.com/dev/postItem',
    keys: [
      'site',
      'uniqueid',
      'category',
      'pagetype',
      'topic',
      'sctndspname',
      'subsection',
      'delivery_channel',
      'classification',
      'adkey1',
      'adkey2',
    ],
  },
};

/**
 * Reports page information to a searchable database to determine page popularity
 * @param {MCPInstance} MCP
 */
export default function fetchReporter(MCP) {
  MCP.addEventListener('initialized', () => {
    const config = MCP.Configurator.getConfiguration({ defaults: defaultConfig }).fetch;

    if (!config.enabled) return;

    const payload = {};

    const shouldReport = Math.round(Math.random() * 100 <= config.reportFrequency);

    if (shouldReport) {
      payload.url = document.location.href;

      config.keys.forEach((entry) => {
        const [metaKey, key] =
          (typeof entry === 'object') ? Object.entries(entry)[0] : [entry, entry];
        payload[key] = MCP.Configurator.meta.page[metaKey] || '';
      });

      fetch(config.endpoint, {
        method: 'POST',
        body: JSON.stringify(payload),
        'Content-Type': 'application/json',
      })
        .catch(() => {});
      consolv.log('MCP: FETCH data sent');
    }
  });
}
